// // src/PermissionService.ts
// import {
//     SubscriptionResponse,
//     LimitsResponse,
//     TeamUsageResponse,
//     ServiceUsageResponse,
//     Permissions,
//     EffectiveLimits,
//     Usage,
//     CanMethods,
//     PlanFeatures,
//     RedisClient
//   } from './types';

//   class PermissionService {
//     // Hardcoded base URL - change this to your actual API base URL
//     private baseURL: string; // REPLACE WITH YOUR ACTUAL API DOMAIN
//     // private readonly baseURL: string = 'http://localhost:3010/'; // REPLACE WITH YOUR ACTUAL API DOMAIN

//     private endpoints = {
//       // getLimits: 'api/v1/membership/planValidation',
//       // getSubscription: 'api/v1/membership/get-subscription', 
//       getLimits: 'payment/api/v1/membership/planValidation',
//       getSubscription: 'payment/api/v1/membership/get-subscription', 
//       getTeamUsage: 'product/api/v1/staff',
//       getServiceUsage: 'product/api/v1/service/providerService/usage'
//     };

//     private redisClient: RedisClient | null = null;
//     private memoryCache = new Map<string, { data: Permissions; timestamp: number }>();
//     private readonly cacheTimeout = 300000; // 5 minutes memory cache
//     private readonly redisCacheTimeout = 1800; // 30 minutes Redis cache
//     private sessionId: string | null = null;
//     constructor(redisClient: RedisClient | null = null, sessionId: string | null = null, baseURL: string) {
//       this.redisClient = redisClient;
//       this.sessionId = sessionId;
//       this.baseURL = baseURL;
//     }

//     setSessionId(sessionId: string): void {
//       this.sessionId = sessionId;
//     }

//     getSessionId(): string | null {
//       return this.sessionId;
//     }

//     async getSubscription(userId: string, sessionId: string | null = null): Promise<SubscriptionResponse> {
//       return this.makeRequest<SubscriptionResponse>(this.endpoints.getSubscription, { userId }, sessionId);
//     }

//     async getLimits(userId: string, sessionId: string | null = null): Promise<LimitsResponse> {
//       return this.makeRequest<LimitsResponse>(this.endpoints.getLimits, { userId }, sessionId);
//     }

//     async getTeamUsage(userId: string, sessionId: string | null = null): Promise<TeamUsageResponse> {
//       return this.makeRequest<TeamUsageResponse>(this.endpoints.getTeamUsage, { userId }, sessionId);
//     }

//     async getServiceUsage(userId: string, sessionId: string | null = null): Promise<ServiceUsageResponse> {
//       return this.makeRequest<ServiceUsageResponse>(this.endpoints.getServiceUsage, { userId }, sessionId);
//     }

//     async getPermissions(userId: string, sessionId: string | null = null): Promise<Permissions> {
//       if (!userId) {
//         throw new Error('User ID is required');
//       }

//       // Try to get from cache first
//       const cached = await this.getFromCache(userId);
//       if (cached) {
//         return cached;
//       }

//       try {
//         const [subscription, limits, teamUsage, serviceUsage] = await Promise.all([
//           this.getSubscription(userId, sessionId),
//           this.getLimits(userId, sessionId),
//           this.getTeamUsage(userId, sessionId),
//           this.getServiceUsage(userId, sessionId)
//         ]);

//         const permissions = this.calculatePermissions(subscription, limits, teamUsage, serviceUsage, userId);

//         // Cache the result
//         await this.setToCache(userId, permissions);

//         return permissions;
//       } catch (error) {
//         console.error('Error getting permissions:', error);
//         throw error;
//       }
//     }

//     async trackUsage(userId: string, type: string, count: number = 1): Promise<void> {
//       try {
//         // Invalidate cache after tracking usage
//         await this.clearCache(userId);
//       } catch (error) {
//         console.error('Error tracking usage:', error);
//         throw error;
//       }
//     }

//     private async getFromCache(userId: string): Promise<Permissions | null> {
//       const cacheKey = `permissions:${userId}`;

//       // Try Redis first if available
//       if (this.redisClient) {
//         try {
//           const cached = await this.redisClient.get(cacheKey);
//           if (cached) {
//             return JSON.parse(cached) as Permissions;
//           }
//         } catch (redisError) {
//           console.warn('Redis cache error, falling back to memory:', redisError);
//         }
//       }

//       // Fallback to memory cache
//       const memoryCached = this.memoryCache.get(cacheKey);
//       if (memoryCached && Date.now() - memoryCached.timestamp < this.cacheTimeout) {
//         return memoryCached.data;
//       }

//       this.memoryCache.delete(cacheKey);
//       return null;
//     }

//     private async setToCache(userId: string, data: Permissions): Promise<void> {
//       const cacheKey = `permissions:${userId}`;

//       // Set in Redis if available
//       if (this.redisClient) {
//         try {
//           await this.redisClient.setex(
//             cacheKey, 
//             this.redisCacheTimeout, 
//             JSON.stringify(data)
//           );
//         } catch (redisError) {
//           console.warn('Redis cache set error, using memory only:', redisError);
//         }
//       }

//       // Always set in memory cache as fallback
//       this.memoryCache.set(cacheKey, {
//         data,
//         timestamp: Date.now()
//       });
//     }

//     async clearCache(userId: string | null = null): Promise<void> {
//       if (userId) {
//         const cacheKey = `permissions:${userId}`;

//         // Clear from Redis
//         if (this.redisClient) {
//           try {
//             await this.redisClient.del(cacheKey);
//           } catch (redisError) {
//             console.warn('Redis cache delete error:', redisError);
//           }
//         }

//         // Clear from memory
//         this.memoryCache.delete(cacheKey);
//       } else {
//         // Clear all - be careful with this in production
//         if (this.redisClient) {
//           try {
//             const keys = await this.redisClient.keys('permissions:*');
//             if (keys.length > 0) {
//               await this.redisClient.del(keys);
//             }
//           } catch (redisError) {
//             console.warn('Redis cache clear all error:', redisError);
//           }
//         }

//         this.memoryCache.clear();
//       }
//     }

//     private calculatePermissions(
//       subscriptionResponse: SubscriptionResponse,
//       limitsResponse: LimitsResponse,
//       teamUsageResponse: TeamUsageResponse,
//       serviceUsageResponse: ServiceUsageResponse,
//       userId: string
//     ): Permissions {
//       const subscriptionData = subscriptionResponse.subscription?.[0];
//       const planData = subscriptionResponse.plan;

//       if (!subscriptionData) {
//         throw new Error('No subscription data found');
//       }

//       const usage: Usage = {
//         servicesCount: serviceUsageResponse.providerUsage || 0,
//         teamMembersCount: teamUsageResponse.total || 0,
//         featuredListingsCount: 0
//       };

//       const effectiveLimits = this.calculateEffectiveLimits(limitsResponse, subscriptionData.activeAddons);
//       const canMethods = this.calculateCanMethods(usage, effectiveLimits, planData.features);

//       const subscriptionInfo = {
//         plan: planData.name,
//         tier: planData.tier,
//         status: subscriptionData.status,
//         billingCycle: subscriptionData.billingCycle,
//         currentPeriodEnd: subscriptionData.currentPeriodEnd,
//         stripeSubscriptionId: subscriptionData.stripeSubscriptionId
//       };

//       return {
//         subscription: subscriptionInfo,
//         usage,
//         limits: effectiveLimits,
//         features: planData.features,
//         addons: subscriptionData.activeAddons,
//         can: canMethods,
//         raw: {
//           subscription: subscriptionResponse,
//           limits: limitsResponse,
//           teamUsage: teamUsageResponse,
//           serviceUsage: serviceUsageResponse
//         }
//       };
//     }

//     // private calculateEffectiveLimits(planData: any, activeAddons: any[]): EffectiveLimits {
//     //   const baseLimits = { ...planData.limits };

//     //   if (activeAddons && activeAddons.length > 0) {
//     //     activeAddons.forEach(addon => {
//     //       if (addon.status === 'active') {
//     //         switch (addon.addon.code) {
//     //           case 'extra_team_member':
//     //             baseLimits.teamMembers += (1 * addon.quantity);
//     //             break;
//     //           case 'extra_service':
//     //             baseLimits.services += (1 * addon.quantity);
//     //             break;
//     //         }
//     //       }
//     //     });
//     //   }

//     //   return {
//     //     maxServices: baseLimits.services,
//     //     maxTeamMembers: baseLimits.teamMembers,
//     //     maxFeaturedListings: baseLimits.featuredListings,
//     //     isUnlimited: false
//     //   };
//     // }

//     // private calculateCanMethods(usage: Usage, limits: EffectiveLimits, features: PlanFeatures): CanMethods {
//     //   return {
//     //     addService: (): boolean => usage.servicesCount < limits.maxServices,
//     //     addTeamMember: (): boolean => usage.teamMembersCount < limits.maxTeamMembers,
//     //     useFeaturedListing: (): boolean => usage.featuredListingsCount < limits.maxFeaturedListings,
//     //     useAdvancedAnalytics: (): boolean => features.analytics === 'advanced',
//     //     useBookingCalendar: (): boolean => features.bookingCalendar === true,
//     //     useTwoWayMessaging: (): boolean => features.messaging === '2-way',
//     //     useCustomBranding: (): boolean => features.branding === true,
//     //     useAdvancedPromoTools: (): boolean => features.promoTools === 'advanced',
//     //     hasReachedServiceLimit: (): boolean => usage.servicesCount >= limits.maxServices,
//     //     hasReachedTeamLimit: (): boolean => usage.teamMembersCount >= limits.maxTeamMembers,
//     //     canUpgrade: (): boolean => true,
//     //     getServiceUsagePercentage: (): number => (usage.servicesCount / limits.maxServices) * 100,
//     //     getTeamUsagePercentage: (): number => (usage.teamMembersCount / limits.maxTeamMembers) * 100
//     //   };
//     // }


//     private calculateEffectiveLimits(limitsResponse: LimitsResponse, activeAddons: any[]): EffectiveLimits {
//       // Start with the base limits from the API response
//       const baseLimits = { 
//         maxServices: limitsResponse.limits.totalServices,
//         maxTeamMembers: limitsResponse.limits.totalTeamMembers,
//         maxFeaturedListings: 0 // You can add this if your API provides it
//       };

//       console.log('[PermissionService] Base limits from API:', baseLimits);
//       console.log('[PermissionService] Active addons:', activeAddons);

//       // Apply addons to increase limits
//       if (activeAddons && activeAddons.length > 0) {
//         activeAddons.forEach(addon => {
//           if (addon.status === 'active') {
//             switch (addon.addon.code) {
//               case 'extra_team_member':
//                 baseLimits.maxTeamMembers += (1 * addon.quantity);
//                 console.log(`[PermissionService] Added ${addon.quantity} team members from addon. New max: ${baseLimits.maxTeamMembers}`);
//                 break;
//               case 'extra_service':
//                 baseLimits.maxServices += (1 * addon.quantity);
//                 console.log(`[PermissionService] Added ${addon.quantity} services from addon. New max: ${baseLimits.maxServices}`);
//                 break;
//             }
//           }
//         });
//       }

//       console.log('[PermissionService] Final effective limits:', baseLimits);

//       return {
//         maxServices: baseLimits.maxServices,
//         maxTeamMembers: baseLimits.maxTeamMembers,
//         maxFeaturedListings: baseLimits.maxFeaturedListings,
//         isUnlimited: limitsResponse.limits.isUnlimited
//       };
//     }

//     private calculateCanMethods(usage: Usage, limits: EffectiveLimits, features: PlanFeatures): CanMethods {
//       const canAddService = usage.servicesCount < limits.maxServices;
//       const canAddTeamMember = usage.teamMembersCount < limits.maxTeamMembers;

//       console.log('[PermissionService] Permission checks:', {
//         services: { used: usage.servicesCount, limit: limits.maxServices, canAdd: canAddService },
//         teamMembers: { used: usage.teamMembersCount, limit: limits.maxTeamMembers, canAdd: canAddTeamMember }
//       });

//       return {
//         addService: (): boolean => canAddService,
//         addTeamMember: (): boolean => canAddTeamMember,
//         useFeaturedListing: (): boolean => usage.featuredListingsCount < limits.maxFeaturedListings,
//         useAdvancedAnalytics: (): boolean => features.analytics === 'advanced',
//         useBookingCalendar: (): boolean => features.bookingCalendar === true,
//         useTwoWayMessaging: (): boolean => features.messaging === '2-way',
//         useCustomBranding: (): boolean => features.branding === true,
//         useAdvancedPromoTools: (): boolean => features.promoTools === 'advanced',
//         hasReachedServiceLimit: (): boolean => usage.servicesCount >= limits.maxServices,
//         hasReachedTeamLimit: (): boolean => usage.teamMembersCount >= limits.maxTeamMembers,
//         canUpgrade: (): boolean => true,
//         getServiceUsagePercentage: (): number => (usage.servicesCount / limits.maxServices) * 100,
//         getTeamUsagePercentage: (): number => (usage.teamMembersCount / limits.maxTeamMembers) * 100
//       };
//     }

//     private async makeRequest<T>(
//       endpoint: string, 
//       params: Record<string, string> = {},
//       sessionId: string | null = null
//     ): Promise<T> {
//       let url = `${this.baseURL}${endpoint}`;

//       // Handle query parameters for specific endpoints
//       if (endpoint === this.endpoints.getLimits && params.userId) {
//         url += `?userId=${params.userId}`;
//       }
//       console.log('[PermissionService] Making API request to', { url, params });
//       const headers: Record<string, string> = {
//         'Content-Type': 'application/json',
//         ...(sessionId && { 'x-session-id': sessionId })
//       };

//       console.log('[PermissionService] Headers', { headers });
//       const options: RequestInit = {
//         method: 'GET',
//         headers,
//         credentials: 'include'
//       };
//       console.log('[PermissionService] Options', { options });
//       console.log(`Making API request to: ${url}`); // Debug log

//       try {
//         const response = await fetch(url, options);
//         console.log('[PermissionService] Response', { response });
//         if (!response.ok) {
//           const errorText = await response.text();
//           throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
//         }
//         console.log('[PermissionService] Response OK');
//         const data = await response.json() as T;
//         console.log('[PermissionService] Data', { data });
//         return data;
//       } catch (error) {
//         console.error(`API request failed for ${url}:`, error);
//         console.log('[PermissionService] Error', { error });
//         throw error;
//       }
//     }

//     // Method to update base URL if needed (for different environments)
//     setBaseURL(baseURL: string): void {
//       (this as any).baseURL = baseURL;
//       // Clear cache when base URL changes
//       this.clearCache();
//       console.log('[PermissionService] Base URL set', { baseURL });
//     }

//     getBaseURL(): string {
//       return this.baseURL;
//     }

//     isRedisConnected(): boolean {
//       return !!(this.redisClient && this.redisClient.connected);
//     }

//     setRedisClient(redisClient: RedisClient): void {
//       this.redisClient = redisClient;
//       console.log('[PermissionService] Redis client set', { redisClient });
//     }
//   }

//   export default PermissionService;



// src/PermissionService.ts
import {
  SubscriptionResponse,
  LimitsResponse,
  TeamUsageResponse,
  ServiceUsageResponse,
  Permissions,
  EffectiveLimits,
  Usage,
  CanMethods,
  PlanFeatures,
  RedisClient
} from './types';

class PermissionService {
  private sessionId: string | null = null;
  private baseURL: string;
  private endpoints = {
    // getLimits: 'api/v1/membership/planValidation',
    // getSubscription: 'api/v1/membership/get-subscription', 
    getLimits: 'payment/api/v1/membership/planValidation',
    getSubscription: 'payment/api/v1/membership/get-subscription',
    getTeamUsage: 'product/api/v1/staff',
    getServiceUsage: 'product/api/v1/service/providerService/usage'
  };

  private redisClient: RedisClient | null = null;
  private memoryCache = new Map<string, { data: Permissions; timestamp: number }>();
  private readonly cacheTimeout = 300000; // 5 minutes memory cache
  private readonly redisCacheTimeout = 1800; // 30 minutes Redis cache

  constructor(redisClient: RedisClient | null = null, sessionId: string | null = null, baseURL: string) {
    this.redisClient = redisClient;
    this.sessionId = sessionId;
    this.baseURL = baseURL;
  }

  setSessionId(sessionId: string): void {
    this.sessionId = sessionId;
  }

  getSessionId(): string | null {
    return this.sessionId;
  }

  async getSubscription(userId: string, sessionId: string | null = null): Promise<SubscriptionResponse> {
    return this.makeRequest<SubscriptionResponse>(this.endpoints.getSubscription, { userId }, sessionId);
  }

  async getLimits(userId: string, sessionId: string | null = null): Promise<LimitsResponse> {
    return this.makeRequest<LimitsResponse>(this.endpoints.getLimits, { userId }, sessionId);
  }

  async getTeamUsage(userId: string, sessionId: string | null = null): Promise<TeamUsageResponse> {
    return this.makeRequest<TeamUsageResponse>(this.endpoints.getTeamUsage, { userId }, sessionId);
  }

  async getServiceUsage(userId: string, sessionId: string | null = null): Promise<ServiceUsageResponse> {
    return this.makeRequest<ServiceUsageResponse>(this.endpoints.getServiceUsage, { userId }, sessionId);
  }

  async getPermissions(userId: string, sessionId: string | null = null): Promise<Permissions> {
    if (!userId) {
      throw new Error('User ID is required');
    }

    // Try to get from cache first
    const cached = await this.getFromCache(userId);
    if (cached) {
      return cached;
    }

    try {
      const [subscription, limits, teamUsage, serviceUsage] = await Promise.all([
        this.getSubscription(userId, sessionId),
        this.getLimits(userId, sessionId),
        this.getTeamUsage(userId, sessionId),
        this.getServiceUsage(userId, sessionId)
      ]);

      const permissions = this.calculatePermissions(subscription, limits, teamUsage, serviceUsage, userId);

      // Cache the result
      await this.setToCache(userId, permissions);

      return permissions;
    } catch (error) {
      console.error('Error getting permissions:', error);
      throw error;
    }
  }

  async trackUsage(userId: string, type: string, count: number = 1): Promise<void> {
    try {
      // Invalidate cache after tracking usage
      await this.clearCache(userId);
    } catch (error) {
      console.error('Error tracking usage:', error);
      throw error;
    }
  }

  private async getFromCache(userId: string): Promise<Permissions | null> {
    const cacheKey = `permissions:${userId}`;

    // Try Redis first if available
    if (this.redisClient) {
      try {
        const cached = await this.redisClient.get(cacheKey);
        if (cached) {
          return JSON.parse(cached) as Permissions;
        }
      } catch (redisError) {
        console.warn('Redis cache error, falling back to memory:', redisError);
      }
    }

    // Fallback to memory cache
    const memoryCached = this.memoryCache.get(cacheKey);
    if (memoryCached && Date.now() - memoryCached.timestamp < this.cacheTimeout) {
      return memoryCached.data;
    }

    this.memoryCache.delete(cacheKey);
    return null;
  }

  private async setToCache(userId: string, data: Permissions): Promise<void> {
    const cacheKey = `permissions:${userId}`;

    // Set in Redis if available
    if (this.redisClient) {
      try {
        await this.redisClient.setex(
          cacheKey,
          this.redisCacheTimeout,
          JSON.stringify(data)
        );
      } catch (redisError) {
        console.warn('Redis cache set error, using memory only:', redisError);
      }
    }

    // Always set in memory cache as fallback
    this.memoryCache.set(cacheKey, {
      data,
      timestamp: Date.now()
    });
  }

  async clearCache(userId: string | null = null): Promise<void> {
    if (userId) {
      const cacheKey = `permissions:${userId}`;

      // Clear from Redis
      if (this.redisClient) {
        try {
          await this.redisClient.del(cacheKey);
        } catch (redisError) {
          console.warn('Redis cache delete error:', redisError);
        }
      }

      // Clear from memory
      this.memoryCache.delete(cacheKey);
    } else {
      // Clear all - be careful with this in production
      if (this.redisClient) {
        try {
          const keys = await this.redisClient.keys('permissions:*');
          if (keys.length > 0) {
            await this.redisClient.del(keys);
          }
        } catch (redisError) {
          console.warn('Redis cache clear all error:', redisError);
        }
      }

      this.memoryCache.clear();
    }
  }

  private calculatePermissions(
    subscriptionResponse: SubscriptionResponse,
    limitsResponse: LimitsResponse,
    teamUsageResponse: TeamUsageResponse,
    serviceUsageResponse: ServiceUsageResponse,
    userId: string
  ): Permissions {
    console.log('[PermissionService] Raw API responses:', {
      subscription: subscriptionResponse,
      limits: limitsResponse,
      teamUsage: teamUsageResponse,
      serviceUsage: serviceUsageResponse
    });

    // FIX: Handle case where user has no active subscription
    const subscriptionData = subscriptionResponse.subscription?.[0];
    const planData = subscriptionResponse.plan;

    // If no active subscription, create a default free plan structure
    if (!subscriptionData) {
      console.log('[PermissionService] No active subscription found, using free plan defaults');
      
      // Create a default free plan structure based on the limits API
      const defaultPlanData = {
        name: 'Free',
        tier: 0,
        limits: {
          services: limitsResponse.limits.totalServices,
          teamMembers: limitsResponse.limits.totalTeamMembers,
          featuredListings: 0
        },
        features: {
          analytics: 'none',
          bookingCalendar: true,
          messaging: 'basic',
          branding: false,
          promoTools: 'none'
        },
        pricing: {
          monthly: { price: 0, stripe_price_id: null },
          yearly: { price: 0, stripe_price_id: null },
          custom: false
        }
      };

      const usage: Usage = {
        servicesCount: serviceUsageResponse.providerUsage || 0,
        teamMembersCount: teamUsageResponse.total || 0,
        featuredListingsCount: 0
      };

      const effectiveLimits = this.calculateEffectiveLimitsFromAPI(limitsResponse, []);
      // Fix usage of PlanFeatures type in canMethods: set correct enum values for analytics, messaging, and promoTools
      const canMethods = this.calculateCanMethods(
        usage,
        effectiveLimits,
        {
          analytics: 'none',
          bookingCalendar: true,
          messaging: 'basic',
          branding: false,
          promoTools: 'none'
        }
      );

      const subscriptionInfo = {
        plan: defaultPlanData.name,
        tier: defaultPlanData.tier,
        status: 'free',
        billingCycle: 'month',
        currentPeriodEnd: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toISOString(), // 30 days from now
        stripeSubscriptionId: null
      };

      return {
        subscription: subscriptionInfo as any,
        usage,
        limits: effectiveLimits,
        features: defaultPlanData.features as PlanFeatures,
        addons: [],
        can: canMethods,
        raw: {
          subscription: subscriptionResponse,
          limits: limitsResponse,
          teamUsage: teamUsageResponse,
          serviceUsage: serviceUsageResponse
        }
      };
    }

    // User has an active subscription - use the original logic
    const usage: Usage = {
      servicesCount: serviceUsageResponse.providerUsage || 0,
      teamMembersCount: teamUsageResponse.total || 0,
      featuredListingsCount: 0
    };

    const effectiveLimits = this.calculateEffectiveLimits(planData, subscriptionData.activeAddons);
    const canMethods = this.calculateCanMethods(usage, effectiveLimits, planData.features);

    const subscriptionInfo = {
      plan: planData.name,
      tier: planData.tier,
      status: subscriptionData.status,
      billingCycle: subscriptionData.billingCycle,
      currentPeriodEnd: subscriptionData.currentPeriodEnd,
      stripeSubscriptionId: subscriptionData.stripeSubscriptionId
    };

    return {
      subscription: subscriptionInfo,
      usage,
      limits: effectiveLimits,
      features: planData.features,
      addons: subscriptionData.activeAddons,
      can: canMethods,
      raw: {
        subscription: subscriptionResponse,
        limits: limitsResponse,
        teamUsage: teamUsageResponse,
        serviceUsage: serviceUsageResponse
      }
    };
  }

  private calculateEffectiveLimitsFromAPI(limitsResponse: LimitsResponse, activeAddons: any[]): EffectiveLimits {
    // Start with limits from the API response
    const baseLimits = {
      maxServices: limitsResponse.limits.totalServices,
      maxTeamMembers: limitsResponse.limits.totalTeamMembers,
      maxFeaturedListings: 0
    };

    console.log('[PermissionService] Base limits from API:', baseLimits);

    // Apply addons if any
    if (activeAddons && activeAddons.length > 0) {
      activeAddons.forEach(addon => {
        if (addon.status === 'active') {
          switch (addon.addon.code) {
            case 'extra_team_member':
              baseLimits.maxTeamMembers += (1 * addon.quantity);
              console.log(`[PermissionService] Added ${addon.quantity} team members from addon. New max: ${baseLimits.maxTeamMembers}`);
              break;
            case 'extra_service':
              baseLimits.maxServices += (1 * addon.quantity);
              console.log(`[PermissionService] Added ${addon.quantity} services from addon. New max: ${baseLimits.maxServices}`);
              break;
          }
        }
      });
    }

    console.log('[PermissionService] Final effective limits:', baseLimits);

    return {
      maxServices: baseLimits.maxServices,
      maxTeamMembers: baseLimits.maxTeamMembers,
      maxFeaturedListings: baseLimits.maxFeaturedListings,
      isUnlimited: limitsResponse.limits.isUnlimited
    };
  }

  private calculateEffectiveLimits(planData: any, activeAddons: any[]): EffectiveLimits {
    const baseLimits = { ...planData.limits };

    if (activeAddons && activeAddons.length > 0) {
      activeAddons.forEach(addon => {
        if (addon.status === 'active') {
          switch (addon.addon.code) {
            case 'extra_team_member':
              baseLimits.teamMembers += (1 * addon.quantity);
              break;
            case 'extra_service':
              baseLimits.services += (1 * addon.quantity);
              break;
          }
        }
      });
    }

    return {
      maxServices: baseLimits.services,
      maxTeamMembers: baseLimits.teamMembers,
      maxFeaturedListings: baseLimits.featuredListings,
      isUnlimited: false
    };
  }

  private calculateCanMethods(usage: Usage, limits: EffectiveLimits, features: PlanFeatures): CanMethods {
    const canAddService = usage.servicesCount < limits.maxServices;
    const canAddTeamMember = usage.teamMembersCount < limits.maxTeamMembers;

    console.log('[PermissionService] Permission calculation:', {
      services: { 
        used: usage.servicesCount, 
        limit: limits.maxServices, 
        canAdd: canAddService,
        calculation: `${usage.servicesCount} < ${limits.maxServices} = ${canAddService}`
      },
      teamMembers: { 
        used: usage.teamMembersCount, 
        limit: limits.maxTeamMembers, 
        canAdd: canAddTeamMember,
        calculation: `${usage.teamMembersCount} < ${limits.maxTeamMembers} = ${canAddTeamMember}`
      }
    });

    return {
      addService: (): boolean => canAddService,
      addTeamMember: (): boolean => canAddTeamMember,
      useFeaturedListing: (): boolean => usage.featuredListingsCount < limits.maxFeaturedListings,
      useAdvancedAnalytics: (): boolean => features.analytics === 'advanced',
      useBookingCalendar: (): boolean => features.bookingCalendar === true,
      useTwoWayMessaging: (): boolean => features.messaging === '2-way',
      useCustomBranding: (): boolean => features.branding === true,
      useAdvancedPromoTools: (): boolean => features.promoTools === 'advanced',
      hasReachedServiceLimit: (): boolean => usage.servicesCount >= limits.maxServices,
      hasReachedTeamLimit: (): boolean => usage.teamMembersCount >= limits.maxTeamMembers,
      canUpgrade: (): boolean => true,
      getServiceUsagePercentage: (): number => (usage.servicesCount / limits.maxServices) * 100,
      getTeamUsagePercentage: (): number => (usage.teamMembersCount / limits.maxTeamMembers) * 100
    };
  }

  private async makeRequest<T>(
    endpoint: string,
    params: Record<string, string> = {},
    sessionId: string | null = null
  ): Promise<T> {
    let url = `${this.baseURL}${endpoint}`;

    // Handle query parameters for specific endpoints
    if (endpoint === this.endpoints.getLimits && params.userId) {
      url += `?userId=${params.userId}`;
    }
    console.log('[PermissionService] Making API request to', { url, params });
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...(sessionId && { 'x-session-id': sessionId })
    };

    console.log('[PermissionService] Headers', { headers });
    const options: RequestInit = {
      method: 'GET',
      headers,
      credentials: 'include'
    };
    console.log('[PermissionService] Options', { options });
    console.log(`Making API request to: ${url}`); // Debug log

    try {
      const response = await fetch(url, options);
      console.log('[PermissionService] Response', { response });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
      }
      console.log('[PermissionService] Response OK');
      const data = await response.json() as T;
      console.log('[PermissionService] Data', { data });
      return data;
    } catch (error) {
      console.error(`API request failed for ${url}:`, error);
      console.log('[PermissionService] Error', { error });
      throw error;
    }
  }

  setBaseURL(baseURL: string): void {
    (this as any).baseURL = baseURL;
    // Clear cache when base URL changes
    this.clearCache();
    console.log('[PermissionService] Base URL set', { baseURL });
  }

  getBaseURL(): string {
    return this.baseURL;
  }

  isRedisConnected(): boolean {
    return !!(this.redisClient && this.redisClient.connected);
  }

  setRedisClient(redisClient: RedisClient): void {
    this.redisClient = redisClient;
  }
}

export default PermissionService;

